<template>
  <v-footer class="h-footer">
    <div class="footer-content">
      <!-- Link section -->
      <div>
        <div class="h-footer-header">{{ $t('components.h_footer.link_title') }}</div>
        <div class="link-list">
          <h-link semi-bold target="_blank" :href="currentLocale === 'fr' ? $urlProvider.HelloTermAndConditionFr : $urlProvider.HelloTermAndConditionEn" :color="linkColor">
            {{ $t('components.h_footer.links.terms_and_condition') }}<v-icon :size="18">mdi-open-in-new</v-icon>
          </h-link>
          <h-link semi-bold target="_blank" :href="currentLocale === 'fr' ? $urlProvider.HelloPrivacyPolicyFr : $urlProvider.HelloPrivacyPolicyEn" :color="linkColor">
            {{ $t('components.h_footer.links.private_life_terms') }}<v-icon :size="18">mdi-open-in-new</v-icon>
          </h-link>
          <h-link semi-bold target="_blank" :href="currentLocale === 'fr' ? $urlProvider.HelloCardholderAgreementFr : $urlProvider.HelloCardholderAgreementEn" :color="linkColor">
            {{ $t('components.h_footer.links.card_agreement') }}<v-icon :size="18">mdi-open-in-new</v-icon>
          </h-link>
          <h-link semi-bold target="_blank" :href="currentLocale === 'fr' ? $urlProvider.HelloCardholderInstantCardAgreementFr : $urlProvider.HelloCardholderInstantCardAgreementEn" :color="linkColor">
            {{ $t('components.h_footer.links.instant_card_agreement') }}<v-icon :size="18">mdi-open-in-new</v-icon>
          </h-link>
        </div>
      </div>

      <!-- SAC section -->
      <div>
        <div class="h-footer-header">{{ $t('components.h_footer.sac_title') }}</div>
        <div class="contact-info">
          <div class="contact">{{ $t('components.h_footer.sac_opening_hour') }}</div>
          <div class="contact">{{ $t('components.h_footer.sac_email') }}</div>
        </div>
        <div class="link-list">
          <h-link semi-bold class="h-footer-link" target="_blank" :href="currentLocale === 'fr' ? $urlProvider.HelloFaqFr : $urlProvider.HelloFaqEn" :color="linkColor" :size="18">
            {{ $t('components.h_footer.links.help') }}<v-icon :size="18">mdi-open-in-new</v-icon>
          </h-link>
          <h-link semi-bold class="h-footer-link" target="_blank" :href="currentLocale === 'fr' ? $urlProvider.HelloBusinessFr : $urlProvider.HelloBusinessEn" :color="linkColor" :size="18">
            {{ $t('components.h_footer.links.business_merchant') }}<v-icon :size="18">mdi-open-in-new</v-icon>
          </h-link>
        </div>
      </div>

      <!-- Legal Notice -->
      <div class="h-caption legal-notice">
        <p v-html="$t('components.h_footer.legal_notice_1')"></p>
        <p>{{ $t('components.h_footer.legal_notice_2') }}</p>
        <p>{{ $t('components.h_footer.legal_notice_3') }}</p>

        <div class="version-text">
          <span class="mr-4">v{{ version }}</span>
          <span>#{{ buildNumber }}</span>
        </div>
      </div>
    </div>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'h-footer',
  inheritAttrs: false,
  data() {
    return {
      buildNumber: process.env.VUE_APP_BUILD_NUMBER,
      version: process.env.VUE_APP_VERSION,
    };
  },
  computed: {
    ...mapGetters('ui', ['currentLocale']),
    linkColor() {
      return 'secondary';
    },
  },
};
</script>

<style lang="scss" scoped>
.h-footer {
  --h-footer-text-color: black;
  --h-footer-background: #fff;

  background-color: var(--h-footer-background);
  color: var(--h-footer-text-color);
  padding: 0px;
  width: min(var(--page-max-width), 100%);
  max-width: var(--page-max-width);
  margin: 0 auto;
}

.footer-content {
  padding: var(--gap);
  display: block;
  width: min(var(--page-content-max-width), 100%);
  & > *:not(:last-child) {
    margin-bottom: 30px;
    @media ($md-min) {
      margin-bottom: 0;
    }
  }

  @media ($md-min) {
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--gap-large);
  }

  @media ($content-min) {
    padding: var(--gap-xxlarge);
  }
}

.h-footer-header {
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 24px;
  @media ($md-min) {
    font-size: 24px;
  }
}

.contact-info {
  margin-bottom: 24px;
  & > *:not(:last-child) {
    margin-bottom: 12px;
  }
}

.v-icon {
  margin-left: 8px !important;
}

.h-link,
.contact {
  font-size: var(--font-size-text-1);
  @media ($md-min) {
    font-size: 16px;
  }
}

.link-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: baseline;
}

.legal-notice {
  font-size: var(--font-size-label-4);
}

.version-text {
  font-size: 10px;
  color: var(--color-ultra-light);
}
.version-text {
  display: none;

  @media ($md-min) {
    display: block;
  }
}
</style>
